import { motion, useReducedMotion } from "framer-motion";

// Lightweight "living mascot" — animates the whole avatar (breathing, blink,
// tail-wag, thinking, happy/cautious body language). CSS transforms only → cheap.
const LOOPS = {
  idle: {
    anim: { scale: [1, 1.035, 1], rotate: [0, 0, 1.6, -1.6, 0, 0] },
    t: {
      scale: { duration: 3.4, repeat: Infinity, ease: "easeInOut" },
      rotate: { duration: 7, repeat: Infinity, ease: "easeInOut", times: [0, 0.55, 0.68, 0.8, 0.92, 1] },
    },
  },
  thinking: {
    anim: { rotate: [0, -4, 3, -2, 0], y: [0, -1.5, 0, -1, 0] },
    t: { duration: 2.1, repeat: Infinity, ease: "easeInOut" },
  },
  happy: {
    anim: { rotate: [0, -8, 8, -6, 6, 0], scale: [1, 1.05, 1] },
    t: { duration: 1.15, repeat: Infinity, ease: "easeInOut" },
  },
  cautious: {
    anim: { rotate: [0, -1.6, 1.6, 0], scale: [1, 1.012, 1] },
    t: { duration: 5, repeat: Infinity, ease: "easeInOut" },
  },
};

export function SofiAvatar({
  size = 96, state = "idle", ringWidth = 2, pop = false, nod = false,
  className = "", testid = "sofi-avatar",
}) {
  const reduce = useReducedMotion();
  const ring = `0 0 0 ${ringWidth}px rgba(199,61,58,0.55)`;

  if (reduce) {
    return (
      <img src="/sofi-avatar.png" alt="Sofi" data-testid={testid} data-state={state}
        className={`rounded-full object-cover ${className}`}
        style={{ width: size, height: size, boxShadow: ring }} />
    );
  }

  const loop = LOOPS[state] || LOOPS.idle;
  const entrance = pop ? { scale: 0.72, opacity: 0 } : nod ? { y: -5, rotate: -5, opacity: 0 } : false;

  return (
    <motion.div className={`relative inline-block ${className}`} style={{ width: size, height: size }}
      data-testid={testid} data-state={state}
      initial={entrance} animate={{ scale: 1, opacity: 1, y: 0, rotate: 0 }}
      transition={{ type: "spring", stiffness: 260, damping: 16 }}>
      {state === "thinking" && (
        <motion.span className="absolute inset-0 rounded-full" style={{ boxShadow: "0 0 0 2px rgba(199,61,58,0.5)" }}
          animate={{ scale: [1, 1.18, 1], opacity: [0.55, 0, 0.55] }}
          transition={{ duration: 1.6, repeat: Infinity, ease: "easeInOut" }} />
      )}
      <motion.div className="h-full w-full" style={{ transformOrigin: "center bottom" }}
        animate={loop.anim} transition={loop.t}>
        <motion.img src="/sofi-avatar.png" alt="Sofi"
          className="h-full w-full rounded-full object-cover"
          style={{ boxShadow: ring, transformOrigin: "center top" }}
          animate={{ scaleY: [1, 1, 1, 0.86, 1, 1] }}
          transition={{ duration: 5.5, repeat: Infinity, ease: "easeInOut", times: [0, 0.72, 0.82, 0.87, 0.92, 1] }} />
      </motion.div>
    </motion.div>
  );
}
